"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagerSearchResultPagingText = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.ManagerSearchResultPagingText = styled_components_1.default.span `
  span {
    font-weight: bold;
  }

  margin-right: 10px;
`;
//# sourceMappingURL=search-result-paging-text.js.map